import { cn } from '@/shared/lib/cn';

/**
 * Eine Nacht, die das Apartment selbst belegt und zugleich Gesamtwohnung oder Zimmer: die Wohnung
 * ist doppelt belegt. Alle drei Kalender nennen sie mit diesem Satz (zugänglicher Name, Legende).
 */
export const DOUBLE_BOOKED_LABEL = 'Doppelt belegt im Verbund';

/**
 * Ein schmaler Strich unter der Buchung — ruhig, aber in keinem Kalender sonst vergeben. Zelle und
 * Legende zeigen ihn in derselben Form; der Grund steht im zugänglichen Namen, nicht in der Farbe.
 */
export function DoubleBookedMark({ className }: { className?: string }) {
  return <span aria-hidden className={cn('bg-sealwax/70 block h-1 rounded-full', className)} />;
}
